"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const tabs = [
    {
        id: "notifications-publiees",
        title: "Publiées",
        link: "/admin/notifications/publiees",
    },
    {
        id: "notifications-programmees",
        title: "Programmées",
        link: "/admin/notifications/programmees",
    },
];
const NotificationNavTabs = () => {
    let location = (0, react_router_dom_1.useLocation)();
    let path = location === null || location === void 0 ? void 0 : location.pathname;
    return (react_1.default.createElement("div", { className: "custom_tabs__wrapper admin__settings__tabs" },
        react_1.default.createElement("ul", { className: "ps-0 settings__tabs tabs__container" }, tabs.map((tab, key) => (react_1.default.createElement(react_router_dom_1.NavLink, { role: "button", className: `tab_item 
                        ${(path === null || path === void 0 ? void 0 : path.startsWith(tab === null || tab === void 0 ? void 0 : tab.link)) ? "tab_item__active" : ""}
                    `, to: `${tab === null || tab === void 0 ? void 0 : tab.link}`, key: key, title: tab === null || tab === void 0 ? void 0 : tab.title },
            react_1.default.createElement("span", null, tab === null || tab === void 0 ? void 0 : tab.title)))))));
};
exports.default = NotificationNavTabs;
